// extracted by mini-css-extract-plugin
export default {"login":"LoginForm_login__YMrgi","logo":"LoginForm_logo__BMFVI","form":"LoginForm_form__HZ40M"};